import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable */
/* 分享类型弹框组件
 * <component-share-type></component-share-type>
 * componentCenter.shareType.showBox(callback) //显示分享类型弹框，
 * callback：点击分享按钮的回调函数，function(type){}  //type：点击分享按钮的类型  1.我的好友  2.我的客户
 */
export default {
  name: "share_type",
  data: function data() {
    return {
      loadShareType: false,
      //加载分享类型弹框
      showShareType: false,
      //显示分享类型弹框
      shareTypeSlideDown: true,
      //分享类型弹框是否滑下，默认true
      callback: function callback(type) {} //点击按钮的回调函数
    };
  },

  mounted: function mounted() {
    _typeof(window.componentCenter) == "object" || (window.componentCenter = {});
    window.componentCenter.shareType = this;
    console.log("ycf组件初始化：shareType");
  },
  methods: {
    //显示弹框
    showBox: function showBox(callback) {
      this.callback = callback;
      if (this.loadShareType) {
        this.slideUpShareType();
      } else {
        this.loadShareType = true;
        this.$nextTick(function () {
          this.slideUpShareType();
        });
      }
    },
    //点击按钮触发的事件，type：点击按钮的类型  1.我的好友  2.我的客户
    clickBtn: function clickBtn(type) {
      var that = this;
      this.slideDownShareType(function () {
        typeof that.callback == "function" && that.callback(type);
      });
    },
    //向上滑动显示分享类型弹框
    slideUpShareType: function slideUpShareType() {
      var that = this;
      that.showShareType = true;
      setTimeout(function () {
        that.shareTypeSlideDown = false;
        location.hash != "#shareType" && (location.hash = "#shareType");
      }, 30);
    },
    //向下滑动隐藏分享类型弹框
    slideDownShareType: function slideDownShareType(callback) {
      var that = this;
      that.shareTypeSlideDown = true;
      setTimeout(function () {
        that.showShareType = false;
        location.hash == "#shareType" && history.go(-1);
        typeof callback == "function" && callback();
      }, 300);
    }
  }
};